<template>
	<div :class="{
		'switch-view': true,
		'active': modelValue
	}" @click.stop="$emit('update:modelValue', !modelValue)">
		<div class="dot"></div>
	</div>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: Boolean,
				required: true
			}
		},
		emits: ['update:modelValue']
	}
</script>

<style lang="scss" scoped>
	.switch-view {
		position: relative;
		width: 40px;
		height: 20px;
		background-color: #f1f1f1;
		border-radius: 10px;

		& > .dot {
			position: absolute;
			top: 2px;
			left: 2px;
			width: 16px;
			height: 16px;
			background-color: rgb(100, 100, 100);
			border-radius: 50%;
		}

		&.active {
			& > .dot {
				left: 22px;
				background-color: #f7223f;
			}
		}
	}
</style>